import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { getActions, updateAction,  createAction} from '../../api/api';
const Action = () => {
  const [actions, setActions] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [newAction, setNewAction] = useState({ name: '', type: '', details: { message: '', emailAddress: '', phoneNumber: '' } });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Fetch all actions with search and pagination
  useEffect(() => {
    fetchActions();
  }, [search, page]);

  const fetchActions = async () => {
    try {
      const response = await getActions( {
        params: { search, page, limit: 10 }
      });
      setActions(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching actions:', error);
    }
  };

  // Handle opening the dialog
  const handleOpen = (action = null) => {
    setSelectedAction(action);
    setNewAction(action ? action : { name: '', type: '', details: { message: '', emailAddress: '', phoneNumber: '' } });
    setOpen(true);
  };

  // Handle closing the dialog
  const handleClose = () => {
    setOpen(false);
    setSelectedAction(null);
  };

  // Handle saving the action (create or update)
  const handleSave = async () => {
    try {
      if (selectedAction) {
        // Update action
        await updateAction(selectedAction._id, newAction);
      } else {
        // Create new action
        await createAction(newAction);
      }
      fetchActions();
      handleClose();
    } catch (error) {
      console.error('Error saving action:', error);
    }
  };

  // Handle page change
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        Actions
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
        <TextField
          label="Search"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ marginRight: 2 }}
        />
        <Button variant="contained" color="primary" onClick={() => handleOpen()}>
          Add New Action
        </Button>
      </Box>
      <TableContainer component={Paper} sx={{ marginTop: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>Email Address</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {actions.map((action) => (
              <TableRow key={action._id}>
                <TableCell>{action.name}</TableCell>
                <TableCell>{action.type}</TableCell>
                <TableCell>{action.details.message}</TableCell>
                <TableCell>{action.details.emailAddress}</TableCell>
                <TableCell>{action.details.phoneNumber}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleOpen(action)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>

      {/* Dialog for adding/updating an action */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{selectedAction ? 'Update Action' : 'Add New Action'}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Name"
            value={newAction.name}
            onChange={(e) => setNewAction({ ...newAction, name: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Type"
            value={newAction.type}
            onChange={(e) => setNewAction({ ...newAction, type: e.target.value })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Message"
            value={newAction.details.message}
            onChange={(e) => setNewAction({ ...newAction, details: { ...newAction.details, message: e.target.value } })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Email Address"
            value={newAction.details.emailAddress}
            onChange={(e) => setNewAction({ ...newAction, details: { ...newAction.details, emailAddress: e.target.value } })}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Phone Number"
            value={newAction.details.phoneNumber}
            onChange={(e) => setNewAction({ ...newAction, details: { ...newAction.details, phoneNumber: e.target.value } })}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Action;
